export function _getUrlParams(url) {
  var i
  url = url || window.location
  url = url.indexOf ? url : url.toString()
  url = decodeURIComponent(url)

  var paramStringStart = url.indexOf('?') + 1,
    paramStringEnd = (url.indexOf('#') === -1) ? url.length : url.indexOf('#'),
    paramString = url.slice(paramStringStart, paramStringEnd),
    keysAndValues = paramString.split('&'),
    paramsObject = {}

  for (i = 0; i < keysAndValues.length; i++) {
    var keyValue = keysAndValues[i].split('=')

    if (keyValue[0].slice(-2) === '[]') {
      var key = keyValue[0].slice(0, -2)
      paramsObject[key] = paramsObject[key] || []
      paramsObject[key].push(keyValue[1])
    } else {
      paramsObject[keyValue[0]] = keyValue[1]
    }
  }

  return paramsObject
}

export function _http2https(adUnits) {
  var httpsMap = {
    'http://cdn-adn.rayjump.com': 'https://cdn-adn-https.rayjump.com',
    'http://res.rayjump.com': 'https://res-https.rayjump.com',
    'http://d11kdtiohse1a9.cloudfront.net': 'https://res-https.rayjump.com'
  }
  for (var i = 0; i < adUnits.length; i++) {
    for (var k in adUnits[i]) {
      for (var key in httpsMap) {
        var reg = new RegExp('' + key + '')
        if (reg.test(adUnits[i][k])) {
          adUnits[i][k] = adUnits[i][k].replace(reg, httpsMap[key])
        }
      }
    }
  }
}

/* 使用JS原生方法获取id元素或者class元素 */
export function _getEl(el, tagName) {
  el = el.replace(/^\s|\s$/g, '')
  // # id . class tag
  var first = el.substr(0, 1)
  // console.log(first);

  if (first === '#') {
    return document.getElementById(el.substr(1, el.length))
  }

  if (first === '.') {
    return document.getElementsByClassName(el.substr(1, el.length))
  }
}
/* 使用JS原生方法删除元素节点，如果这个节点有父节点的话 */
export function _rmEl(el) {
  var oParent = el.parentNode
  if (oParent) {
    oParent.removeChild(el)
  }
}

export function _addClass(el, className) {
  var reg = new RegExp('' + className + '')
  if (!reg.test(el.className)) {
    // if dosent exsist
    el.className += (' ' + className)
  }
}

export function _rmClass(el, className) {
  var reg = new RegExp('' + className + '')
  if (reg.test(el.className)) {
    el.className = el.className.replace(reg, '')
  }
}

export function _language() {
  var type = navigator.appName
  var lang = ''
  if (type == 'Netscape') {
    lang = navigator.language
  } else {
    lang = navigator.userLanguage
  }
  lang = lang.substr(0, 2)
  switch (lang) {
    case 'en':
      break
    case 'zh':
      break
    default:
      lang = 'other'
  }
  return lang
}

export function _ajax(type, url, data, success, failed) {
  // 创建ajax对象
  if (typeof data == 'object') {
    var str = '';
    for (var key in data) {
      str += key + '=' + data[key] + '&';
    }
    data = str.replace(/&$/, '');
  }
  type = type.toUpperCase();
  if (type == 'GET') {
    if (data) {
      xhr.open('GET', url + '?' + data, true);
    } else {
      xhr.open('GET', url, true);
    }
    xhr.send();

  } else if (type == 'POST') {
    xhr.open('POST', url, true);
    // 如果需要像 html 表单那样 POST 数据，请使用 setRequestHeader() 来添加 http 头。
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.send(data);
  } else if (type == 'POSTJSON') {
    xhr.open('POST', url, true);
    // 如果需要像 html 表单那样 POST 数据，请使用 setRequestHeader() 来添加 http 头。
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
  }

  // 处理返回数据
  xhr.onreadystatechange = function () {
    if (xhr.readyState == 4) {
      if (xhr.status == 200) {
        success(xhr.responseText);
      } else {
        if (failed) {
          failed(xhr.responseText);
        }
      }
    }
  }
}

export function _statistics(url, silentTag) {
  var reg = /(http\:|https\:)/
  silentTag = silentTag || 'script'
  url = url.replace(reg, '')
  var silentDataUrlString = url
  var oTag = document.createElement(silentTag)
  oTag.setAttribute('src', silentDataUrlString)
  document.body.appendChild(oTag)
}

// 判断页面滚动方向
export function _scrollFunc() {
  var scrollAction = {
    x: 0,
    y: 0
  },
    scrollDirection
  var diffX = scrollAction.x - window.pageXOffset
  var diffY = scrollAction.y - window.pageYOffset
  // console.log(diffX, diffY)
  if (diffX < 0) {
    // Scroll right
    scrollDirection = 'right'
  } else if (diffX > 0) {
    // Scroll left
    scrollDirection = 'left'
  } else if (diffY < 0) {
    // Scroll down
    scrollDirection = 'down'
  } else if (diffY > 0) {
    // Scroll up
    scrollDirection = 'up'
  } else {
    // First scroll event
    // console.log(11111)
    scrollDirection = ''
  }
  scrollAction.x = window.pageXOffset
  scrollAction.y = window.pageYOffset
  // console.log(scrollAction, scrollDirection)
  return scrollDirection
}

// 文档高度
export function _getDocumentTop() {
  var scrollTop = 0,
    bodyScrollTop = 0,
    documentScrollTop = 0
  if (document.body) {
    bodyScrollTop = document.body.scrollTop
  }
  if (document.documentElement) {
    documentScrollTop = document.documentElement.scrollTop
  }
  scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop
  return scrollTop
}

// 可视窗口高度
export function _getWindowHeight() {
  var windowHeight = 0
  if (document.compatMode == 'CSS1Compat') {
    windowHeight = document.documentElement.clientHeight
  } else {
    windowHeight = document.body.clientHeight
  }
  return windowHeight
}

// 可视窗口宽度
export function _getWindowWidth() {
  var windowWidth = 0
  if (document.compatMode == 'CSS1Compat') {
    windowWidth = document.documentElement.clientWidth
  } else {
    windowWidth = document.body.clientWidth
  }
  return windowWidth
}

// 滚动条滚动高度
export function _getScrollHeight() {
  var scrollHeight = 0,
    bodyScrollHeight = 0,
    documentScrollHeight = 0
  if (document.body) {
    bodyScrollHeight = document.body.scrollHeight
  }
  if (document.documentElement) {
    documentScrollHeight = document.documentElement.scrollHeight
  }
  scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight
  return scrollHeight
}

export function _device() {
  var u = navigator.userAgent
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  return {
    isAndroid: isAndroid,
    isiOS: isiOS
  }
}

export function _toggleLogo() {
  var i
  var parm = _getUrlParams()
  var rVersion = /(mal|mi)/ig
  if (parm && parm.sdk_version) {
    if (rVersion.test(parm.sdk_version)) {
      for (i = 0; i < _getEl('.logo').length; i++) {
        _rmClass(_getEl('.logo')[i], 'none')
      }
    }
  }
}

/*
 * Interfaces:
 * utf8 = utf16to8(utf16);
 * utf16 = utf8to16(utf8);
 */
export function _utf16to8(str) {
  var out, i, len, c
  out = ''
  len = str.length
  for (i = 0; i < len; i++) {
    c = str.charCodeAt(i)
    if ((c >= 0x0001) && (c <= 0x007F)) {
      out += str.charAt(i)
    } else if (c > 0x07FF) {
      out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F))
      out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F))
      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F))
    } else {
      out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F))
      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F))
    }
  }
  return out
}

export function _utf8to16(str) {
  var out, i, len, c
  var char2, char3
  out = ''
  len = str.length
  i = 0
  while (i < len) {
    c = str.charCodeAt(i++)
    switch (c >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        // 0xxxxxxx
        out += str.charAt(i - 1)
        break
      case 12:
      case 13:
        // 110x xxxx 10xx xxxx
        char2 = str.charCodeAt(i++)
        out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F))
        break
      case 14:
        // 1110 xxxx 10xx xxxx 10xx xxxx
        char2 = str.charCodeAt(i++)
        char3 = str.charCodeAt(i++)
        out += String.fromCharCode(((c & 0x0F) << 12) |
          ((char2 & 0x3F) << 6) |
          ((char3 & 0x3F) << 0))
        break
    }
  }
  return out
}

export function _fnIsPortrait() {
  var isOrientation = ('orientation' in window && 'onorientationchange' in window),
    meta = ''
  // iframe中orientation并不准确
  if (isOrientation && window.self === window.top) {
    // eslint-disable-next-line no-undef
    if (orientation === 180 || orientation === 0) {
      meta = 'portrait'
    }
    // eslint-disable-next-line no-undef
    if (orientation === 90 || orientation === -90) {
      meta = 'landscape'
    }
  } else {
    if (window.innerWidth > window.innerHeight) { // 初始化判断
      meta = 'landscape'
    } else {
      meta = 'portrait'
    }
  }
  return meta === 'portrait'
}

export function _getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return decodeURIComponent(r[2])
  return null
}
//插入星级，获取星星评级
export function getStar(rate) {
  let fullStar = 0;
  let halfStar = 0;
  let curStar = 0;
  if (parseFloat(rate) > 5 || parseFloat(rate) < 1) {
    fullStar = 5;//整星
    halfStar = 0;//半星
    curStar = 5;//当前的星星
  } else {
    fullStar = parseInt(rate);
    halfStar = Math.ceil((parseFloat(rate) % 1) / 0.5);
    curStar = fullStar + 0.5 * halfStar;
  }
  return curStar * 2;
}

/**
 * 尝试从当前上下文中读取 sdkInfo, 将多余的前后缀移除, 并返回净化后的 MAJOR.MINOR.PATCH 形式版本号
 * 注意: 由于历史原因, iOS 和安卓 SDK 的版本号存在特殊前缀, 安卓大部分版本还会存在特殊后缀
 * iOS 版本号示例: MI_5.9.0
 * Android 版本号示例: MAL_12.2.0,3.0.1
 * @returns {string} 返回净化后的版本号
 */
export function _getPureSDKVersion(sdkInfo) {
  if (sdkInfo === '') {
    console.log('当前传入的版本号为空，不再处理，直接返回')
    return sdkInfo
  }

  let version = String(sdkInfo)
  // 移除 _ 前的前缀
  version = version.split('_').slice(-1)[0]
  // 移除 , 后的后缀
  version = typeof version === 'string' && version.split(',')[0]

  /**
   * 注意:
   * 安卓的版本号有一个特殊的规则, 如果测试包为 12.2.0, 则 release 包的版本号会存在两个 12.2.01 和 12.2.02,
   * 最后额外附加的数字 1 和 2 代表 SDK 投放的渠道，1 用来发国内(12.2.01), 2 用来发国外(12.2.02),
   * 所以这里判断安卓版本号的时候, 需要把最后一位 1/2 的渠道标识去掉
   */
  if (_device().isAndroid && typeof version === 'string') {
    let tmpVersion = version.slice(0, -1)
    if (tmpVersion.slice(-1) === '.') {
      console.log('当前版本号后缀只有一位, 推测应该是安卓测试包, 不再尝试截取')
    } else {
      console.log('当前版本号后缀大于一位, 推测应该是安卓渠道包, 在返回的版本号中移除渠道标识')
      version = tmpVersion
    }
  }

  return version;
}

/**
 * 比较两个以小数点分隔的版本号, 并返回比较结果 (v1 大于, 等于或小于 v2)
 * @param {string|[]} v1 当前要比较的第一个版本号
 * @param {string|[]} v2 当前要比较的第二个版本号
 * @returns {number} 有三种返回结果:
 * 1. 返回 1, 表示 v1 的版本号大于 v2
 * 2. 返回 0, 表示 v1 的版本号等于 v2
 * 3. 返回 -1, 表示 v1 的版本号小于 v2
 * @example 举个栗子:
 * _compareVersion('10.11.0', '10.9.9') // 1
 * _compareVersion('12.2.0', '12.2.0') // 0
 * _compareVersion('9.999.999', '11.0.0') // -1
 */
export function _compareVersion(v1, v2) {
  // console.log({v1, v2})
  if (typeof v1 === "undefined" || typeof v2 === "undefined") {
    console.error('请指定要对比的两个版本号', {v1, v2})
    return
  }

  v1 = v1.split('.')
  v2 = v2.split('.')
  const maxLength = Math.max(v1.length, v2.length)

  // 补全
  while (v1.length < maxLength) {
    v1.push('0')
  }
  while (v2.length < maxLength) {
    v2.push('0')
  }

  for (let i = 0; i < maxLength; i++) {
    let num1 = parseInt(v1[i])
    let num2 = parseInt(v2[i])

    if (num1 > num2) {
      return 1
    } else if (num1 < num2) {
      return -1
    }
  }

  return 0
}